import React, { useCallback, useState, useEffect } from "react";
import {
  DropZone,
  Page,
  FormLayout,
  Card,
  Badge,
  Select,
  Modal,
  Text,
  Loading,
  Toast,
  Spinner,
  ProgressBar,
  TextContainer,
  PageActions,
  Checkbox,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { DeleteMinor } from "@shopify/polaris-icons";
import "react-circular-progressbar/dist/styles.css";
import moment from "moment";

const ContactDetails = () => {
  const { id } = useParams();
  const [ts, setTs] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState("");

  useEffect(() => {
    axios
      .get(`/crm/contacts/${id}`)
      .then((result) => {
        console.log("contact=", result.data.data);
        setResult(result.data.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [ts]);

  return result ? (
    <Page
      title={
        result?.first_name && result?.last_name
          ? result?.first_name + " " + result?.last_name
          : ""
      }
      breadcrumbs={[{ onAction: () => navigate("/admin/crm/contacts") }]}
    >
      {isLoading ? <Loading /> : null}
      <FormLayout>
        {result && (
          <div>
            <Card sectioned title="CONTACT DETAILS">
              <FormLayout>
                <FormLayout.Group condensed>
                  <div className="columnFlex">
                    <b>Company Name</b>
                    <p style={{ height: "0.4rem" }} />
                    {result?.name ? result?.name : "N/A"}
                  </div>

                  <div className="columnFlex">
                    <b>Email</b>
                    <div style={{ height: "0.4rem" }} />{" "}
                    {result?.email ? result?.email : "N/A"}
                  </div>
                  <div className="columnFlex">
                    <b>Address</b>
                    <div style={{ height: "0.4rem" }} />{" "}
                    {result?.address ? result?.address : "N/A"}
                  </div>
                </FormLayout.Group>
                <FormLayout.Group condensed>
                  <div className="columnFlex">
                    <b>Created at</b>
                    <div style={{ height: "0.4rem" }} />
                    {result?.created_at
                      ? moment(result?.created_at).format("YYYY-MM-DD HH:mm:ss")
                      : "N/A"}
                  </div>
                </FormLayout.Group>
              </FormLayout>
            </Card>
          </div>
        )}
      </FormLayout>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
};
export default ContactDetails;
